var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 33,
    viewBox: "0 0 37 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.3125C0 1.69919 0.243638 1.11099 0.677316 0.677316C1.11099 0.243638 1.69919 0 2.3125 0H34.6875C35.3008 0 35.889 0.243638 36.3227 0.677316C36.7564 1.11099 37 1.69919 37 2.3125C37 2.92581 36.7564 3.51401 36.3227 3.94768C35.889 4.38136 35.3008 4.625 34.6875 4.625H2.3125C1.69919 4.625 1.11099 4.38136 0.677316 3.94768C0.243638 3.51401 0 2.92581 0 2.3125ZM0 16.1875C0 15.5742 0.243638 14.986 0.677316 14.5523C1.11099 14.1186 1.69919 13.875 2.3125 13.875H34.6875C35.3008 13.875 35.889 14.1186 36.3227 14.5523C36.7564 14.986 37 15.5742 37 16.1875C37 16.8008 36.7564 17.389 36.3227 17.8227C35.889 18.2564 35.3008 18.5 34.6875 18.5H2.3125C1.69919 18.5 1.11099 18.2564 0.677316 17.8227C0.243638 17.389 0 16.8008 0 16.1875ZM2.3125 27.75C1.69919 27.75 1.11099 27.9936 0.677316 28.4273C0.243638 28.861 0 29.4492 0 30.0625C0 30.6758 0.243638 31.264 0.677316 31.6977C1.11099 32.1314 1.69919 32.375 2.3125 32.375H34.6875C35.3008 32.375 35.889 32.1314 36.3227 31.6977C36.7564 31.264 37 30.6758 37 30.0625C37 29.4492 36.7564 28.861 36.3227 28.4273C35.889 27.9936 35.3008 27.75 34.6875 27.75H2.3125Z",
    fill: "#2F91F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.8ba197883230da857a15afc1308669bd.svg";
export { ForwardRef as ReactComponent };